import React from 'react'
import { useInView } from "react-intersection-observer";

import {SiFigma} from "react-icons/si"
import {SiAdobexd} from "react-icons/si"
import {DiPhotoshop} from "react-icons/di"
import {DiIllustrator} from "react-icons/di"

const DesignTools = () => {
    //   Intersection Observer
    const {ref: designToolsSectionTitleRef, inView: designToolsSectionTitleIsVisible } = useInView({ 
        triggerOnce: true
    });

    return (
        <section className="designtools-section">
            <div className="designtools-title-div">
                <h1 ref={designToolsSectionTitleRef} className={`${designToolsSectionTitleIsVisible ? "designTools-title show-title" : "designTools-title"}`}>Design kit</h1>
                <div className="title-underline"></div>
                </div>
                
                <div className="designtools-container">
                <div className="designtool-div">
                    <SiFigma className="designtool-icon"/>
                    <div className="design-tool">Figma</div>
                </div>

                <div className="designtool-div">
                    <SiAdobexd className="designtool-icon"/>
                    <div className="design-tool">Adobe XD</div>
                </div>

                <div className="designtool-div">
                    <DiPhotoshop className="designtool-icon"/>
                    <div className="design-tool">Photoshop</div>
                </div>

                <div className="designtool-div">
                    <DiIllustrator className="designtool-icon"/>
                    <div className="design-tool">Illustrator</div>
                </div>
            </div>
        </section>
    )
}

export default DesignTools